interface CompanyPromoSectionProps {
  data: string;
}

export default function CompanyPromoSection({ data }: CompanyPromoSectionProps) {

  return (
    <div>
      {/* 标题区域 */}
      <div className="px-4 py-3 border-b border-gray-100 flex items-center">
        <div className="flex items-center gap-2 flex-1">
          <h3 className="text-base font-bold text-gray-900">企业宣传</h3>
          <p className="text-xs text-gray-400 tracking-widest ml-1">COMPANY PROMO</p>
        </div>
      </div>

      {/* 轮播区域 */}
      <div className="p-4">
        <div className="relative rounded-xl overflow-hidden bg-gray-900 group">
          {/* 主展示区 */}
          <div className="aspect-video relative">
            <video
                src={data}
                className="w-full h-full object-cover"
                controls
                playsInline
              />
          </div>
        </div>
      </div>
    </div>
  );
}
